import { ArticleItem } from '../../types';

export const aprilInnovativeMedicalDevicesEn: ArticleItem = {
  slug: "april-innovative-medical-devices",
  title: "15 Medical Devices Entered the Innovation Channel in April",
  summary: "A total of 15 medical devices entered the innovative medical device special review application results summary in April.",
  seo: {
    title: "15 Medical Devices Entered the Innovation Channel in April | HL Medical",
    description: "A summary table shows 15 medical devices entering the innovative medical device special review application results in April.",
    keywords: "innovative medical device, special review, China medical device innovation channel, medical device registration",
    canonicalUrl: "https://hlmedicalconsult.cn/en/articles/april-innovative-medical-devices",
    alternateUrls: {
      en: "https://hlmedicalconsult.cn/en/articles/april-innovative-medical-devices",
      cn: "https://hlmedicalconsult.cn/cn/articles/april-innovative-medical-devices",
      xDefault: "https://hlmedicalconsult.cn/en/articles/april-innovative-medical-devices"
    },
    ogTitle: "15 Medical Devices Entered the Innovation Channel in April",
    ogDescription: "A summary of innovative medical device special review application results for April.",
    ogType: "article"
  },
  date: "2026-05-08",
  category: "Innovation",
  readTime: "2 min read",
  sourceName: "HIGH-USABILITY",
  originalUrl: "https://www.highusability.com",
  sourceNote: "source: High Usability: www.high-usability.com",
  content: [
    { type: "section", text: "01" },
    { type: "heading", text: "April Innovation Channel Summary" },
    { type: "paragraph", text: "A total of 15 medical devices entered the innovation channel in April." },
    { type: "heading", text: "Summary Table of Innovative Medical Device Special Review Application Results" },
    {
      type: "table",
      columns: ["No.", "Product Name", "Applicant"],
      rows: [
        ["1", "Peripheral point stent system", "归创通桥医疗科技股份有限公司"],
        ["2", "Ceramic dental implant system", "北京瑞瓷医疗科技有限公司"],
        ["3", "Patent foramen ovale suturing device", "无忧跳动医疗科技（深圳）有限公司"],
        ["4", "Steep pulse therapy device", "杭州维纳安可医疗科技有限责任公司"],
        ["5", "Foldable capsular vitreous body for eyes with posterior segment deficiency", "无锡卡尔蔡司蕾明视康医疗科技有限公司"],
        ["6", "Urethral filler", "成都高瑟生物科技有限公司"],
        ["7", "Additively manufactured patient-matched PEEK rib prosthesis", "维度（西安）生物医疗科技有限公司"],
        ["8", "Drug-eluting peripheral arterial stent system", "上海鸣脉医疗科技有限公司"],
        ["9", "Shoulder arthroplasty surgical navigation and positioning system", "北京埃斯顿医疗科技有限公司"],
        ["10", "Non-small cell lung cancer drug sensitivity detection kit (in vitro cell culture method)", "北京基石医学检验实验室有限公司"],
        ["11", "Upper gastrointestinal electronic endoscope surgical control system", "上海澳华内镜股份有限公司"],
        ["12", "3D-printed tissue engineering scaffold for breast reconstruction", "深圳博瑞硅生物科技有限公司"],
        ["13", "Microsurgical control system", "昂泰微精医疗科技（上海）有限公司"],
        ["14", "Chest CT image-assisted diagnostic software", "上海联影智能科技股份有限公司"],
        ["15", "Intracranial deep electrode", "北京智冉医疗科技有限公司"]
      ]
    }
  ]
};

export const aprilInnovativeMedicalDevicesCn: ArticleItem = {
  slug: "april-innovative-medical-devices",
  title: "4月共15款医疗器械进入创新通道",
  summary: "创新医疗器械特别审查申请审查结果公示汇总表。",
  seo: {
    title: "4月共15款医疗器械进入创新通道 | 赫莱医药",
    description: "4月共15款医疗器械进入创新通道，文章展示创新医疗器械特别审查申请审查结果公示汇总表。",
    keywords: "创新医疗器械, 医疗器械创新通道, 特别审查, 医疗器械注册",
    canonicalUrl: "https://hlmedicalconsult.cn/cn/articles/april-innovative-medical-devices",
    alternateUrls: {
      en: "https://hlmedicalconsult.cn/en/articles/april-innovative-medical-devices",
      cn: "https://hlmedicalconsult.cn/cn/articles/april-innovative-medical-devices",
      xDefault: "https://hlmedicalconsult.cn/en/articles/april-innovative-medical-devices"
    },
    ogTitle: "4月共15款医疗器械进入创新通道",
    ogDescription: "创新医疗器械特别审查申请审查结果公示汇总表。",
    ogType: "article"
  },
  date: "2026-05-08",
  category: "创新器械",
  readTime: "约2分钟",
  sourceName: "HIGH-USABILITY",
  originalUrl: "https://www.highusability.com",
  sourceNote: "source: High Usability: www.high-usability.com",
  content: [
    { type: "section", text: "01" },
    { type: "heading", text: "4月创新通道汇总" },
    { type: "paragraph", text: "4月共15款医疗器械进入创新通道。" },
    { type: "heading", text: "创新医疗器械特别审查申请审查结果公示汇总表" },
    {
      type: "table",
      columns: ["序号", "产品名称", "申请人"],
      rows: [
        ["1", "外周点状支架系统", "归创通桥医疗科技股份有限公司"],
        ["2", "陶瓷牙种植体系统", "北京瑞瓷医疗科技有限公司"],
        ["3", "卵圆孔未闭缝合器", "无忧跳动医疗科技（深圳）有限公司"],
        ["4", "陡脉冲治疗仪", "杭州维纳安可医疗科技有限责任公司"],
        ["5", "环曲面后房有晶体眼人工晶状体", "无锡卡尔蔡司蕾明视康医疗科技有限公司"],
        ["6", "尿道填充剂", "成都高瑟生物科技有限公司"],
        ["7", "增材制造聚醚醚酮患者匹配式胸肋骨假体", "维度（西安）生物医疗科技有限公司"],
        ["8", "药物洗脱外周动脉支架系统", "上海鸣脉医疗科技有限公司"],
        ["9", "肩关节置换手术导航定位系统", "北京埃斯顿医疗科技有限公司"],
        ["10", "非小细胞肺癌药物敏感性检测试剂盒（体外细胞培养法）", "北京基石医学检验实验室有限公司"],
        ["11", "上消化道电子内窥镜手术控制系统", "上海澳华内镜股份有限公司"],
        ["12", "3D打印乳房重建组织工程支架", "深圳博瑞硅生物科技有限公司"],
        ["13", "显微外科手术控制系统", "昂泰微精医疗科技（上海）有限公司"],
        ["14", "胸部CT图像辅助诊断软件", "上海联影智能科技股份有限公司"],
        ["15", "颅内深部电极", "北京智冉医疗科技有限公司"]
      ]
    }
  ]
};
